export const ProductPurchaseRptConstants ={
    GETALL_REQUEST: 'PRODUCTPURCHASER_GETALL_REQUEST',
    GETALL_SUCCESS: 'PRODUCTPURCHASER_GETALL_SUCCESS',
    GETALL_FAILURE: 'PRODUCTPURCHASER_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'PRODUCTPURCHASER_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'PRODUCTPURCHASER_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'PRODUCTPURCHASER_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST'
}